import { defineMessages } from 'react-intl';

export const pointExpirationScheduleMessages = defineMessages({
  'point-expiration-schedule:html-title': {
    id: 'point-expiration-schedule:html-title',
    defaultMessage: 'Point Expiration',
  },
  'point-expiration-schedule:page-title': {
    id: 'point-expiration-schedule:page-title',
    defaultMessage: 'Point Expiration',
  },
  'point-expiration-schedule:schedule-title': {
    id: 'point-expiration-schedule:schedule-title',
    defaultMessage: 'Points Expiring Soon',
  },
  'point-expiration-schedule:no-expiring-points': {
    id: 'point-expiration-schedule:no-expiring-points',
    defaultMessage: 'No points expiring',
  },
  'point-expiration-schedule:no-expiring-points-description': {
    id: 'point-expiration-schedule:no-expiring-points-description',
    defaultMessage: 'Expiring points will display here',
  },
  'point-expiration-schedule:expiring-soon': {
    id: 'point-expiration-schedule:expiring-soon',
    defaultMessage: 'Expiring soon',
  },
  'point-expiration-schedule:points-expiring': {
    id: 'point-expiration-schedule:points-expiring',
    defaultMessage: 'Points Expiring',
  },
  'point-expiration-schedule:expiring-soon-header': {
    id: 'point-expiration-schedule:expiring-soon-header',
    defaultMessage: 'Expiring soon',
  },
  'point-expiration-schedule:expiring-next-header': {
    id: 'point-expiration-schedule:expiring-next-header',
    defaultMessage: 'Expiring Next',
  },
  'point-expiration-schedule:expiring-soon-banner': {
    id: 'point-expiration-schedule:expiring-soon-banner',
    defaultMessage: 'Points expiring! Tap for details',
    description: 'Warning message when points are expiring soon',
  },
});
